import type * as React from "react";

import { Field, TextInput } from "@/shared/foundation/primitives";

interface TextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  /** Helper text under the input. */
  description?: React.ReactNode;
  placeholder?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  disabled?: boolean;
}

/** A labelled text input for the AI settings forms. */
export function TextField({
  label,
  value,
  onChange,
  description,
  placeholder,
  inputMode,
  disabled = false,
}: TextFieldProps) {
  return (
    <Field.Root>
      <Field.Label>{label}</Field.Label>
      <Field.Control
        render={<TextInput />}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        inputMode={inputMode}
        disabled={disabled}
      />
      {description !== undefined && (
        <Field.Description>{description}</Field.Description>
      )}
    </Field.Root>
  );
}
